import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ComponentRef,
  ViewContainerRef,
} from '@angular/core';
import { Menu } from '@grapecity/wijmo.input';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { GetMultiCodeListService } from './api-services/get-multi-code-list.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { EventArgs } from '@grapecity/wijmo';
import { DataGridUtil } from '../../../commons/kymw00/data-grid-util';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';

import { KYMW0300OutputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { KYMW0300Component } from '../../../commons/kymw03/kymw0300/kymw0300.component';

import { KYMW4700Model } from './kymw4700.model';
import { KYMW4701Component } from '../kymw4701/kymw4701.component';
import { KYMW0300Model } from '../../../commons/kymw03/kymw0300/kymw0300.model';

/**
 * マルチコード画面を管理するクラス
 *
 * @export KYMW4700Component
 * @class KYMW4700Component
 */
@Component({
  selector: 'app-kymw4700',
  templateUrl: 'kymw4700.component.html',
  styleUrls: ['kymw4700.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW4700Component
  extends PlessViewHelperSub
  implements OnInit, AfterViewInit
{
  public model: KYMW4700Model = new KYMW4700Model();

  // 商品検索ダイアログ
  public kymw0300Component: KYMW0300Component;
  public kymw0300Model: KYMW0300Model = new KYMW0300Model();

  private contextForMultiCode: Menu;

  @ViewChild('dtg_MultiCodeList', { static: true }) dtg_MultiCodeList: FlexGrid;

  /**
   * Creates an instance of KYMW4700Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW4700Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    public viewContainerRef: ViewContainerRef,
    private getMultiCodeListService: GetMultiCodeListService
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW4700Component
   */
  public ngOnInit(): void {
    this.model.kymw4700Component = this;
    this.componentName = 'KYMW4700';

    // コンテキストメニュー表示
    this.dtg_MultiCodeList.hostElement.addEventListener('contextmenu', e => {
      e.preventDefault();
      DataGridUtil.showContextMenu(
        this.dtg_MultiCodeList,
        this.contextForMultiCode,
        e
      );
    });

    // 一覧クリック時 選択行の更新
    this.dtg_MultiCodeList.hostElement.addEventListener('click', e => {
      e.preventDefault();
    });

    this.createContextMenu();

    // マルチコード一覧取得処理
    this.getMultiCodeListService.execute(this.model);
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW4700Component
   */
  public ngAfterViewInit(): void {
    if (this.dtg_MultiCodeList) {
      this.dtg_MultiCodeList.itemsSourceChanged.addHandler(
        (_g: FlexGrid, _e: EventArgs) => _g.select(-1, -1)
      );
    }
  }

  /**
   * コンテキストメニュー作成
   *
   * @memberof KYMW4700Component
   */
  private createContextMenu(): void {
    this.contextForMultiCode = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [{ caption: '詳細', cmd: 'detail', enabled: true }],
      command: {
        canExecuteCommand: param => {
          if (this.isPermittedReadOnly) return false;
          return param.enabled;
        },
      },
      itemClicked: () => {
        if (this.contextForMultiCode.selectedValue === 'detail') this.detail();
      },
    });
  }

  /**
   * コンテキストメニュー
   *
   * @memberof KYMW4700Component
   */
  private detail() {
    // マルチ商品設定画面(モーダレス)を表示する。
    // データ取得条件の設定
    const selItem = this.dtg_MultiCodeList.selectedItems[0];
    if (!selItem?.MultiCode) return;

    // マルチ商品設定画面呼び出し
    const componentRef = this.dialogService.openModal(KYMW4701Component);
    const instance = componentRef.componentInstance as KYMW4701Component;
    instance.parent = this;
    instance.setInterfaceParam({ multiCode: selItem.MultiCode });
    instance.closeFunction = () => {
      componentRef.close();
      this.getMultiCodeListService.execute(this.model);
    };
  }

  /**
   * 検索ボタン押下イベント
   */
  public eventSeach_CLICKHandler(): void {
    // 商品検索画面(モーダル)を表示する。
    this.model.kymw0300input.catalogSearchFlg = 0;    // 企画検索フラグ:0（企画関連条件を非表示）
    const kymw0300ComponentRef =
      this.dialogService.openModal(KYMW0300Component);
    if (kymw0300ComponentRef != null) {
      this.kymw0300Component =
        kymw0300ComponentRef.componentInstance as KYMW0300Component;
      this.kymw0300Component.parent = this;
      this.kymw0300Component.setInterfaceParam(this.model.kymw0300input);
      this.kymw0300Component.setKYMW0300Parameter = (
        outputVO: KYMW0300OutputModel
      ) => this.setKYMW0300Parameter(outputVO);
    }
    // ウィンドウが閉じられる際の処理
    this.kymw0300Component.closeFunction = () => {
      kymw0300ComponentRef.close();
    };
  }

  /**
   * 商品検索にて検索押下後の処理
   */
  public setKYMW0300Parameter(outputVO: KYMW0300OutputModel): void {
    this.model.kymw0300output = outputVO;
    Object.entries(outputVO).forEach(([k, v]) => {
      if (k in this.model.kymw0300input) this.model.kymw0300input[k] = v;
    });

    // 検索条件を保持
    this.model.kymw0300input = this.kymw0300Model.getKYMW0300SearchHistory(outputVO);

    this.model.dataKbnFlg = outputVO.dataKbnFlg? 'true': 'false';

    //  商品検索画面を閉じる
    this.kymw0300Component.closeFunction();

    // マルチコード一覧取得
    this.clearList();
    this.getMultiCodeListService.execute(this.model);
  }

  /**
   * 一覧クリア
   */
  public clearList(): void {
    // 一覧クリア
    this.model.pageNum = 1;
    this.model.reqPageNum = 1;
    this.model.totalNum = 0;
    this.model.startDispNum = 0;
    this.model.endDispNum = 0;
    this.model.multiCodeList = [];
  }

  /**
   * 「前へ」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventPrev_CLICKHandler(): void {
    // ページを設定
    this.model.reqPageNum = this.model.pageNum - 1;
    // マルチコード一覧取得処理
    this.getMultiCodeListService.execute(this.model, () => {
      // ページ番号をデクリメント(-1)
      this.model.pageNum = this.model.reqPageNum;
    });
  }

  /**
   * 「次へ」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventNext_CLICKHandler(): void {
    // ページを設定
    this.model.reqPageNum = this.model.pageNum + 1;
    // マルチコード一覧取得処理
    this.getMultiCodeListService.execute(this.model, () => {
      // ページ番号をインクリメント(+1)
      this.model.pageNum = this.model.reqPageNum;
    });
  }
}
